import axios, { AxiosInstance } from 'axios';
import config from '@config';

/**
 * Creates an axios instance configured for the scenarios simulator API
 *
 * @param token - Bearer token for authentication
 * @returns Configured axios instance
 */
export function createScenariosSimulatorApiClient(token?: string): AxiosInstance {
  const instance = axios.create({
    baseURL: `${config.CALCULATOR_NEW_API_HOST}/api`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: false,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && typeof window !== 'undefined') {
        const { protocol, host } = window.location;
        const currentDomain = `${protocol}//${host}`;
        const serverPort = config.SERVER_PORT ?? '5001';
        const normalizedHost = host.replace(/:\d+$/, '');
        const hostWithPort = config.IS_IN_PRODUCTION === true ? normalizedHost : `${normalizedHost}:${serverPort}`;
        const serverBaseURL = `${protocol}//${hostWithPort}/api/auth`;
        window.location.href = `${serverBaseURL}/logout`;
      }
      return Promise.reject(error);
    },
  );

  return instance;
}
